const ImagePreview = ({ image, onClick }) => {
    if (!image) return null;
    const src = image instanceof File ? URL.createObjectURL(image) : image;
    return (
        <div className="mb-2">
            <img
                src={src}
                alt="Current Cover"
                className="max-h-20 w-[100px]"
                onClick={() => onClick(src)}
                style={{ cursor: "pointer" }}
            />
        </div>
    );
};

export default ImagePreview;